import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@fluentui/react/lib/Stack';
import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Title3,
} from '@fluentui/react-components';
import { ArrowDownload20Filled } from '@fluentui/react-icons';

export const DownloadMenu = ({
  onClickExcel,
  onClickJson,
}) => {
  const i18n = useContext(I18nContext);
  const downloadLabel = i18n.getString(_TL_('Download'));
  const excelLabel = i18n.getString(_TL_('Excel'));
  const jsonLabel = i18n.getString(_TL_('JSON'));

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button>
          <ArrowDownload20Filled />
          {downloadLabel}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem onClick={onClickExcel}>{excelLabel}</MenuItem>
          <MenuItem onClick={onClickJson}>{jsonLabel}</MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

DownloadMenu.propTypes = {
  onClickExcel: PropTypes.func.isRequired,
  onClickJson: PropTypes.func.isRequired,
};

export const ResultsPageHeader = ({
  onClickExcel,
  title,
}) => {
  const i18n = useContext(I18nContext);
  const pageDescription = i18n.getString(_TL_('View your reports for conversion lift, search lift, and visit lift. We report specific data points for each lift measurement type: Conversion rate, brand search rate, and website visitation rate. These measurements help you understand how much more likely consumers are to search for your brand, visit your website, and convert on your website after seeing your Audience ads.'));
  const downloadLabel = i18n.getString(_TL_('Download'));

  return (
    <div className="results-page-header">
      <Stack horizontal horizontalAlign="space-between">
        <Title3>{title}</Title3>
        <Button onClick={onClickExcel} className="download-results-btn">
          <ArrowDownload20Filled />
          {downloadLabel}
        </Button>
      </Stack>
      <p>
        <LearnMoreLink
          linkText={i18n.getString(_TL_('Learn more'))}
          text={pageDescription}
          topic="app54859"
        />
      </p>
    </div>
  );
};

ResultsPageHeader.propTypes = {
  onClickExcel: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
